import { useCallback, useEffect, useState } from "react"
import UserService from "services/UserService"
import { Guid } from "@/types"

interface IUseUserEmailsParams {
    userIds: Guid[]
}

export default function useUserEmails({ userIds }: IUseUserEmailsParams) {
    const [emails, setEmails] = useState<{ [key: string]: string }>({})
    const [isFetching, setIsFetching] = useState(false)

    const fetchEmails = useCallback(async () => {
        if (!userIds.length) {
            return
        }
        setIsFetching(true)
        const emailsResp = await UserService.getUserEmailsByIds(userIds)
        setEmails(emailsResp)
        setIsFetching(false)
    }, [userIds])

    useEffect(() => {
        fetchEmails()
    }, [fetchEmails])

    const getEmail = useCallback((userId?: Guid) => {
        return userId ? (emails[userId] || "") : ""
    }, [emails])

    return {
        emails,
        isFetchingEmails: isFetching,
        getEmail,
    }
}
